import { useEffect } from 'react';

const lockBodyScroll = () => {
  const body = document?.body;
  if (!body) return;
  body.dataset.scrollLock = body.style.overflow || '';
  body.style.overflow = 'hidden';
};

const unlockBodyScroll = () => {
  const body = document?.body;
  if (!body) return;
  const previous = body.dataset.scrollLock;
  body.style.overflow = previous || '';
  delete body.dataset.scrollLock;
};

export const useBodyScrollLock = (shouldLock = true) => {
  useEffect(() => {
    if (!shouldLock) return;
    lockBodyScroll();
    return () => {
      unlockBodyScroll();
    };
  }, [shouldLock]);
};

export default useBodyScrollLock;
